import type { InventoryReconcileAttempt } from "~fulfill/inventory/stock/helpers/inventoryReconcileDraft";

import isRecord from "~/helpers/isRecord";

const isInventoryReconcileAttempt = (value: unknown): value is InventoryReconcileAttempt =>
	isRecord(value) &&
	typeof value.itemName === "string" &&
	typeof value.locationName === "string" &&
	isRecord(value.input) &&
	typeof value.input.itemId === "string" &&
	typeof value.input.locationId === "string" &&
	Number.isFinite(value.input.quantity) &&
	Number.isFinite(value.input.grade);

export default isInventoryReconcileAttempt;
